"use client"

import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react"
import { type FC } from "react"

import { QuoteLeftIcon, QuoteRightIcon } from "@/components/icons"
import { type QuoteBlock as QuoteBlockType } from "@/types/database"

interface QuoteBlockProps {
  block: QuoteBlockType
}

const QuoteBlock: FC<QuoteBlockProps> = ({ block }) => {
  const { content, darker_bg, subtitle, title } = block
  return (
    <HStack
      bgColor={darker_bg ? "bg.subtle" : "transparent"}
      className="quote-block internal-padding"
    >
      <Box
        bgColor="bg.subtle"
        borderLeftColor="primary.500"
        borderLeftWidth="4px"
        borderRadius="0"
        pb={6}
        position="relative"
        pt={10}
        px={12}
      >
        <Icon
          as={QuoteLeftIcon}
          boxSize={6}
          color="primary.500"
          left={4}
          opacity={0.3}
          position="absolute"
          top={4}
        />

        <VStack alignItems="flex-start" gap={4}>
          {content && (
            <Text
              color="fg.muted"
              fontFamily="header"
              fontSize="2xl"
              fontStyle="italic"
            >
              {content}
            </Text>
          )}

          <VStack alignItems="flex-start" gap={1} width="100%">
            {title && (
              <Text fontSize="sm" fontWeight="bold">
                {title}
              </Text>
            )}
            {subtitle && (
              <Text color="fg.subtle" fontSize="xs">
                {subtitle}
              </Text>
            )}
          </VStack>
        </VStack>

        <Icon
          as={QuoteRightIcon}
          bottom={4}
          boxSize={6}
          color="primary.500"
          opacity={0.3}
          position="absolute"
          right={4}
        />
      </Box>
    </HStack>
  )
}

export default QuoteBlock
